// Generated by CoffeeScript 2.7.0
var PushPackageListItem;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import EditPushPackageModal from 'trunks/vue/admin/compositions/push_package/push_package_modal/edit_push_package_modal.js';

export default PushPackageListItem = Vue.extend({
  components: {
    Popover: Popover
  },
  props: {
    pushPackage: {
      type: Object
    },
    selectedId: {
      type: [String, Number]
    },
    resourceUrl: {
      type: String
    },
    editModalTitle: {
      type: String
    }
  },
  data: function() {
    return {
      showPopover: false
    };
  },
  template: `<div class="list-item node-wrapper justify-between"
     :class="{ selected: selected }"
     @click="pushPackageChange">
  <div class="name">
    <span>{{pushPackage.name}}</span>
  </div>
  <Popover position='bottom right'
           size="small"
           @beforeOpen="popoverBeforeOpen"
           @beforeClose="popoverBeforeClose"
           ref="popoverRef">
    <template slot="trigger">
      <div :class='nodeClass' @click.stop="togglePopover">
        <i class="slp-ellipsis-circle-o"></i>
      </div>
    </template>
    <div class="list" slot="content">
      <div class="list-item" @click="openPushPackageModalFunc">
        <i class="slp-pencil"></i>
        <span class="ml-2">编辑推送包</span>
      </div>
      <div class="list-item" @click.stop="deletePushPackage">
        <i class="slp-trash"></i>
        <span class="ml-2">删除推送包</span>
      </div>
    </div>
  </Popover>
</div>`,
  computed: {
    selected: function() {
      return parseInt(this.selectedId) === this.pushPackage.id;
    },
    nodeClass: function() {
      return {
        "node-hover": !this.showPopover,
        "node-show": this.showPopover
      };
    }
  },
  methods: {
    pushPackageChange: function() {
      return this.$emit('selectedPushPackageChange', this.pushPackage.id);
    },
    popoverBeforeOpen: function() {
      return this.showPopover = true;
    },
    popoverBeforeClose: function() {
      return this.showPopover = false;
    },
    togglePopover: function(event) {
      return this.$refs.popoverRef.togglePopover();
    },
    openPushPackageModalFunc: function() {
      this.togglePopover();
      return new EditPushPackageModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('edit-push-package-modal'),
        propsData: {
          title: this.editModalTitle,
          initialPushPackage: this.pushPackage,
          callback: (pushPackage) => {
            return this.editPushPackageFunc(pushPackage);
          }
        }
      });
    },
    editPushPackageFunc: function(pushPackage) {
      return Skylark.Libs.Ajax.put(`${this.resourceUrl}/${pushPackage.id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          push_package: pushPackage
        },
        success: (data) => {
          Skylark.Bridge.newAlertify('编辑成功', {
            type: 'success'
          });
          return this.$emit('pushPackageChanged', pushPackage);
        },
        error: function(xhr, status, errors) {
          return Skylark.Bridge.newAlertify(errors.join('，'), {
            type: 'error'
          });
        }
      });
    },
    deletePushPackage: function() {
      return newConfirm({
        icon: "<i class='slp-warning-circle-o'></i>",
        title: '是否删除此推送包',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'danger'
      }).$on('ensureClicked', () => {
        return Skylark.Libs.Ajax.delete(`${this.resourceUrl}/${this.pushPackage.id}`, {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          success: () => {
            this.$emit('deletedPushPackage', this.pushPackage);
            return Skylark.Bridge.newAlertify('删除推送包成功', {
              type: 'success'
            });
          },
          error: function() {
            return Skylark.Bridge.newAlertify('删除推送包失败', {
              type: 'error'
            });
          }
        });
      });
    }
  }
});
